
var buttonLess = {};
import genaration from '../../utils/classname';
export var buttonClass = genaration(buttonLess, 'button');